import { FC, memo, useState } from 'react';
import { Modal } from 'shared/ui';
import { Form } from 'features/Form';
import { createEngineMeasurement } from 'entities/engineMeasurement';
import { EngineMeasurementRequestDto } from 'shared/api';
import { useGlobalSpinner } from 'shared/hooks';
import { useAppDispatch } from 'app/providers/Store';
import { App } from 'antd';
import { ENGINE_MEASUREMENT_FORM_FIELDS } from '../../../constants/engineMeasurementConstants';
import styles from './EngineMeasurementForm.module.scss';

interface EngineMeasurementFormProps {
  engineId: number;
  onClose: () => void;
  onSuccess?: () => void;
}

export const EngineMeasurementForm: FC<EngineMeasurementFormProps> = memo(({
  engineId,
  onClose,
  onSuccess,
}) => {
  const { message } = App.useApp();
  const { showSpinner, hideSpinner } = useGlobalSpinner();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: Record<string, number>) => {
    try {
      setIsSubmitting(true);
      showSpinner('Создание измерения...');

      const requestData: EngineMeasurementRequestDto = {
        engineId,
        engineHours: data.engineHours,
        countOfStarts: data.countOfStarts,
        equivalentHours: data.equivalentHours,
        temperatureStatorU: data.temperatureStatorU,
        temperatureStatorV: data.temperatureStatorV,
        temperatureStatorW: data.temperatureStatorW,
        temperatureBrgDe: data.temperatureBrgDe,
        temperatureBrgNde: data.temperatureBrgNde,
        temperatureAirH: data.temperatureAirH,
        temperatureAirC: data.temperatureAirC,
        vibrationDe: data.vibrationDe,
        vibrationNde: data.vibrationNde,
      };

      await dispatch(createEngineMeasurement(requestData)).unwrap();

      message.success('Изменения успешно сохранены');
      onSuccess?.();
      onClose();
    } catch (error) {
      message.error('Ошибка при сохранении измерений');
      console.error('Failed to create engine measurement:', error);
    } finally {
      setIsSubmitting(false);
      hideSpinner();
    }
  };

  return (
    <Modal
      title="Добавить измерения"
      open
      onCancel={onClose}
      width={800}
      footer={null}
    >
      <div className={styles.formContainer}>
        <Form
          fields={ENGINE_MEASUREMENT_FORM_FIELDS}
          onSubmit={handleSubmit}
          onCancel={onClose}
          loading={isSubmitting}
          submitText="Сохранить измерения"
          cancelText="Отмена"
          columns={2}
        />
      </div>
    </Modal>
  );
});

EngineMeasurementForm.displayName = 'EngineMeasurementForm';
